var merge = function merge(dataArray) {
  var rst = [];

  for (var i = 0; i < dataArray.length; i++) {
    rst = rst.concat(dataArray[i]);
  }

  return rst;
};

module.exports = merge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/array/merge.js
// module id = 49
// module chunks = 0 1 2